import { h, t } from 'infrastructure/targets/web/modules/common/helpers';

const getAPIBaseURL = () => {
  const sentryEnv = import.meta.env.VITE_SENTRY_ENV;
  // Check if we're in production environment
  if (sentryEnv?.search(/production/) === 0) {
    return 'https://fiveirongolf.com/wp-admin/admin-ajax.php';
  }
  // Check if we're on localhost
  if (location.host.search(/localhost/) === 0) {
    return 'http://wordpress.test/wp-admin/admin-ajax.php';
  }
  // Default to development environment
  return 'https://fivedevelop.wpengine.com/wp-admin/admin-ajax.php';
};

const activeCampaignContactConversion = () => {
  const newEmail = localStorage.getItem('new_email');
  const encodedEmail = localStorage.getItem('email');
  const conversionSet = localStorage.getItem('conversion_sent');
  const shared_secret = import.meta.env.VITE_MARKETING_SITE_SHARED_SECRET;

  // Only proceed if we have required data and haven't already sent conversion
  if (!newEmail || !encodedEmail || conversionSet || !shared_secret) {
    return;
  }

  const sendConversion = async () => {
    try {
      const email = decodeURI(encodedEmail);

      // Mark conversion as sent immediately to prevent duplicate requests
      localStorage.setItem('conversion_sent', 'true');

      const baseUrl = getAPIBaseURL();
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Authorization: 'Private ' + h(shared_secret + t(new Date().getTime())),
        'X-Requested-With': 'XMLHttpRequest',
      };

      const data = new URLSearchParams();
      data.append('action', 'activecampaign_api_bridge');
      data.append('call', 'transfer_history');
      data.append('oldUserEmail', email);
      data.append('newUserEmail', newEmail);

      const response = await fetch(baseUrl, {
        method: 'POST',
        headers: headers,
        body: data,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Update email storage on successful conversion
      const currentNewEmail = localStorage.getItem('new_email');
      if (currentNewEmail && currentNewEmail !== 'undefined') {
        localStorage.setItem('email', currentNewEmail);
        localStorage.removeItem('new_email');
      }

      console.log('ActiveCampaign conversion successful:', result);
    } catch (error) {
      console.error('ActiveCampaign conversion failed:', error);

      // Reset conversion flag on error so it can be retried
      localStorage.removeItem('conversion_sent');
    }
  };

  sendConversion();
};

export default activeCampaignContactConversion;
